import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '../Link';

import styles from './index.scss';

const Banner = ({ link, img, altText, extendClass }) => {
    const bannerImg = (
        <img
            src={img}
            alt={altText}
            loading="lazy"
            className={classNames({ [styles.BannerImg]: true, [extendClass]: extendClass })}
        />
    );

    return link ? (
        <Link to={link} className={styles.Banner}>
            {bannerImg}
        </Link>
    ) : (
        <div className={styles.Banner}>{bannerImg}</div>
    );
};

Banner.propTypes = {
    link: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    altText: PropTypes.string.isRequired,
    extendClass: PropTypes.string,
};

export default Banner;
